import { useState, useEffect } from "react";
import axios from "axios";
import API_ENDPOINTS from "config/api";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Rating from "@mui/material/Rating";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import DataTable from "examples/Tables/DataTable";

export default function Evaluaciones() {
  const [evaluaciones, setEvaluaciones] = useState([]);

  useEffect(() => {
    const fetchEvaluaciones = async () => {
      try {
        const response = await axios.get(API_ENDPOINTS.RRHH.EVALUACIONES);
        setEvaluaciones(response.data);
      } catch (error) {
        console.error("Error al cargar evaluaciones:", error);
      }
    };
    fetchEvaluaciones();
  }, []);

  const columns = [
    { Header: "No. Empleado", accessor: "numEmpleado", width: "12%" },
    { Header: "empleado", accessor: "empleado", width: "25%" },
    { Header: "período", accessor: "periodo", width: "12%" },
    { Header: "tipo", accessor: "tipo", width: "15%" },
    { Header: "puntuación", accessor: "puntuacion", width: "15%" },
    { Header: "estatus", accessor: "estatus", width: "12%" },
    { Header: "acciones", accessor: "acciones", width: "10%" },
  ];

  const rows = evaluaciones.map((item) => ({
    numEmpleado: (
      <MDTypography variant="caption" fontWeight="medium">
        {item.numEmpleado}
      </MDTypography>
    ),
    empleado: <MDTypography variant="caption">{item.empleado}</MDTypography>,
    periodo: <MDTypography variant="caption">{item.periodo}</MDTypography>,
    tipo: <MDTypography variant="caption">{item.tipo}</MDTypography>,
    puntuacion: item.puntuacion ? (
      <MDBox display="flex" alignItems="center">
        <Rating value={item.puntuacion} precision={0.5} readOnly size="small" />
        <MDTypography variant="caption" ml={1}>
          {item.puntuacion}
        </MDTypography>
      </MDBox>
    ) : (
      <MDTypography variant="caption" color="text">
        -
      </MDTypography>
    ),
    estatus: (
      <MDTypography
        variant="caption"
        color={item.estatus === "Completada" ? "success" : "warning"}
        fontWeight="bold"
      >
        {item.estatus}
      </MDTypography>
    ),
    acciones: (
      <MDBox display="flex" gap={1}>
        <MDButton variant="text" color="info" size="small" iconOnly>
          <Icon>{item.estatus === "Completada" ? "visibility" : "edit"}</Icon>
        </MDButton>
      </MDBox>
    ),
  }));

  return (
    <MDBox>
      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} md={3}>
          <Card>
            <MDBox p={3} textAlign="center">
              <MDTypography variant="caption">Evaluaciones Completadas</MDTypography>
              <MDTypography variant="h3" color="success">
                3
              </MDTypography>
            </MDBox>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card>
            <MDBox p={3} textAlign="center">
              <MDTypography variant="caption">Evaluaciones Pendientes</MDTypography>
              <MDTypography variant="h3" color="warning">
                1
              </MDTypography>
            </MDBox>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card>
            <MDBox p={3} textAlign="center">
              <MDTypography variant="caption">Puntuación Promedio</MDTypography>
              <MDTypography variant="h3" color="info">
                4.43
              </MDTypography>
            </MDBox>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card>
            <MDBox p={3} textAlign="center">
              <MDTypography variant="caption">Período Actual</MDTypography>
              <MDTypography variant="h3" color="dark">
                2024-Q4
              </MDTypography>
            </MDBox>
          </Card>
        </Grid>
      </Grid>

      <Card>
        <MDBox p={3}>
          <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
            <MDTypography variant="h6" fontWeight="medium">
              Evaluaciones de Desempeño
            </MDTypography>
            <MDButton variant="gradient" color="info">
              <Icon>add</Icon>&nbsp;Nueva Evaluación
            </MDButton>
          </MDBox>

          <DataTable
            table={{ columns, rows }}
            showTotalEntries={true}
            isSorted={true}
            noEndBorder
            entriesPerPage={true}
          />
        </MDBox>
      </Card>
    </MDBox>
  );
}
